import React from 'react';
const NEEDS = [{
  need: 'Need a Cooling System diagnostic map?',
  answer: 'It’s there.'
}, {
  need: 'Need an Airflow troubleshooting pathway?',
  answer: 'It’s there.'
}, {
  need: 'Need an Electrical & Control reference?',
  answer: 'It’s there.'
}, {
  need: 'Need Refrigerant & Pressure diagnostics?',
  answer: ''
}, {
  need: 'Compressor & Outdoor Unit troubleshooting?',
  answer: ''
}, {
  need: 'Symptom-based Field Troubleshooting Maps?',
  answer: ''
}];
export function ReadyToUse() {
  return <section className="bg-charcoal px-4 py-5 sm:py-7" data-id="element-159" data-mp="26nai9jy6wyv6">
      <div className="mx-auto max-w-3xl" data-id="element-160" data-mp="26lpmjr0539vq">
        <h2 className="text-center text-xl leading-tight text-white sm:text-3xl" data-id="element-161" data-mp="2beisujb9aq9x">
          ⏱️ Less searching. More ready-to-use diagnostics.
        </h2>

        <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-162" data-mp="2gfolyi8twfjz">
          {NEEDS.map(({
          need,
          answer
        }) => <li key={need} className="rounded-md border-l-4 border-diag bg-white/5 px-3 py-2 text-sm font-medium leading-snug text-white" data-id="element-163" data-mp="2kdme9txwbhrl">
              {need}
              {answer && <span className="ml-1 font-extrabold text-diag" data-id="element-164" data-mp="35wsuxk4xzh1p">{answer}</span>}
            </li>)}
        </ul>

        <p className="mt-3 text-center font-display text-lg uppercase leading-tight text-white sm:text-2xl" data-id="element-165" data-mp="30yhir2r6cugb">
          Open the system. Choose the problem. Find the map. Follow the path.
        </p>
      </div>
    </section>;
}